var map = {
	"./Legend_PrefabWall1.jpg": 805,
	"./Legend_PrefabWall2.jpg": 8202,
	"./Legend_PrefabWall3.jpg": 2039,
	"./Legend_PrefabWall4.jpg": 844,
	"./Legend_PrefabWall5.jpg": 8889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 515;